<template>
  <div class="input-block-btn">
    <WsIconBtn
      v-show="itemVersionCreatable"
      :size="40"
      @click="$_onCreateVersionClick()"
      tooltip="更新版本"
    >mdi-update</WsIconBtn>
    <div v-if="isTopicList">
      <WsIconBtn
        v-if="openActive"
        :size="40"
        class="ml-1 mr-1"
        tooltip="收合"
        @click="$_readActiveToggle()"
      >
        mdi-unfold-less-horizontal
      </WsIconBtn>
      <WsIconBtn
        v-else
        :size="40"
        tooltip="展開"
        class="ml-1 mr-1"
        @click="$_readActiveToggle()"
      >
        mdi-unfold-more-horizontal
      </WsIconBtn>
    </div>
    <WsIconBtn
      v-show="arrayLength>1"
      @click="$emit('deleteList')"
      :size="40"
      class="ml-1 mr-1"
      tooltip="刪除"
    >mdi-delete</WsIconBtn>
  </div>
</template>
<script>
export default {
  name: "InputBlockBtn",
  data: () => ({}),
  props: {
    openActive: {
      type: Boolean,
      default: false,
    },
    arrayLength: {
      type: Number,
      default: 0,
    },
    isTopicList: {
      type: Boolean,
      defatul: false,
    },
    itemVersionCreatable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_readActiveToggle() {
      this.$emit("activeToggle", !this.openActive);
    },
    $_onCreateVersionClick() {
      this.$emit("createVersionClick");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/__vue2cmsstonevuetify/assets/scss/input-block-btn.scss";
</style>